import { Box, Typography } from "@mui/material";

const SectionWrapper = ({ title, children }) => (
  <Box
    sx={{
      maxWidth: "1600px",
      margin: "70px 0px",
      width: "100%",
      boxSizing: "border-box",
      px: { xs: 2, sm: 4 },
    }}
  >
    <Typography
      // variant="h5"
      sx={{
        fontFamily: "Inter500",
        fontWeight: 500,
        mb: 3,
        fontSize: { xs: "20px", sm: "24px", md: "24px" },
        color: "#000000",
        textAlign:"center"
      }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);

export default SectionWrapper;
